import { request } from '../utils';
import { ROOT_SERVER_URL } from '../config';

export { getAuditEvents } from './auditEvent';
export {
  getAccount,
  getPolicies,
  getRestoreRequests,
  getRestoreRequest,
  requestRestore,
  approveRestoreRequest,
  countRestoreRequest,
  cancelRestoreRequest,
} from './aws';
export {
  createBuildConfig,
  updateBuildConfig,
  getBuildConfigs,
  removeBuildConfig,
  addBuildParameter,
  addBuildParameters,
  updateBuildParameter,
  getBuildParameters,
  removeBuildParameter,
  removeConfigParameters,
  getDefaultBuildWithParameters,
  getMatchedBuildConfigs,
  cloneBuildConfiguration,
  getInheritedBuildParameters,
  getSuggestions,
  getParameterNames,
  addParameterName,
  updateParameterNameData,
  deleteParameterName,
  getParameterValues,
  addParameterValueData,
  updateParameterValue,
  deleteParameterValue,
  getFinalParameters,
  runBuilds,
  getTriggeredBuilds,
  getParentBuildConfigs,
  createBuildNote,
  updateBuildNote,
  deleteBuildNote,
  changeBuildConfigStatus,
  type TriggeredBuild,
  type BuildNote,
} from './build-config';
export { clearAllCache, getCacheStats } from './cache';
export {
  addCloudfrontEnabledBucket,
  getCloudfrontEnabledBuckets,
  removeCloudfrontEnabledBucket,
  type CloudfrontBucketsConfig,
} from './app-config';
export { getSystemStats } from './system';
export {
  changeCategoryDefault,
  createEmailTemplate,
  deleteEmailTemplate,
  getEmailReplacementsForCategory,
  getEmailTemplateCategories,
  getEmailTemplates,
  parseEmailTemplates,
  parseEmailTemplate,
  sendEmail,
  updateEmailTemplate,
} from './emails';
export { createExternalKey, deleteExternalKey, getGroupExternalKeys, updateExternalKey } from './externalKeys';
export {
  createGroup,
  deleteGroup,
  getGroup,
  getGroups,
  updateGroup,
  addUsersToGroup,
  getGroupUsers,
  updateUserGroupRoles,
  removeUserFromGroup,
  addGroupAwsPrincipal,
  getGroupAwsPrincipals,
  removeGroupAwsPrincipal,
  enableAtfHttpsAccess,
  revokeAtfHttpsAccess,
} from './group';
export { getGroupRoles } from './groupRole';
export {
  getServiceDataFeeds,
  getDataFeedInventoryRegression,
  getDataFeedInventoryServiceStatus,
  getDataFeedInventorySummary,
  resolveDataFeedInventoryRegression,
  getDataFeed,
  getDataFeedApprovalServices,
  getDataFeedsApprovalService,
  addDataFeed,
  updateDataFeed,
  refreshAndGetDataFeedInventorySummary,
  getPathDetails,
  updatePathDetails,
  updateMetadata,
  getDataFeedMetadata,
  type DataFeedInventorySummaryRow,
} from './dataFeed';
export { addVenue, deleteVenue, getVenues, updateVenue, type MarketVenueFormValues, type MarketVenueRow } from './venues';
export {
  getSLATasks,
  getSLATask,
  createSLATask,
  updateSLATask,
  deleteSLATask,
  getSLATaskAffectedClients,
  getSLATaskExecutionHistory,
  getSLATaskRaisedAlerts,
} from './slaTask';
export { getInternalPermissions } from './internalPermissions';
export {
  createFeature,
  createFeatureGroup,
  createLicenseTemplate,
  deleteFeature,
  deleteFeatureGroup,
  deleteLicenseTemplate,
  editFeature,
  editFeatureAndGroupDependencies,
  editFeatureGroup,
  editLicense,
  editLicenseTemplate,
  generateLicense,
  getActualFeatures,
  getAllFeaturesAndGroups,
  getFeatureGroups,
  getGeneratedLicenses,
  getGeneratedLicensesGroups,
  getGroupedFeatures,
  getLicenseTemplate,
  getLicenseTemplateFeaturesAndGroups,
  getLicenseTemplates,
  uploadLicenseFile,
} from './licenses';
export {
  createOrganization,
  getOrganization,
  getOrganizations,
  updateOrganization,
  getOrganizationUsers,
  type Organization,
} from './organization';
export {
  createGroupPermission,
  deleteGroupPermission,
  deletePermissionMetadata,
  getGroupFeedsPermissions,
  getExpiredGroupFeedsPermissions,
  getGroupPermissions,
  getPermissionApprovals,
  getPermissionMetadata,
  getDataFeedPermissionApprovals,
  putPermissionApproval,
  putPermissionMetadata,
  updatePermissionApproval,
  getServicePermissionSummary,
  putGroupFeedsPermissions,
  getDataInventoryServicePermissions,
  getWorkbenchPermissions,
  getGroupWorkbenchInstancePermissions,
  putGroupWorkbenchInstancePermissions,
} from './permissions';
export {
  convertKey,
  createSshKey,
  getSshKey,
  getSshKeys,
  grantServiceAccess,
  updateSshKey,
  removeSshKey,
  revokeServiceAccess,
} from './sshKey';
export { cancelExecution, getExecutions, getTasks, triggerTask } from './task';
export { confirmUser, createUser, disableUser, enableUser, getAllUsers, getUser, sendInvitationEmail, updateUser } from './user';
export { getWorkbenchInstances } from './workbenchInstance';
export {
  createWbPlan,
  getLoginDefaults,
  getOrganizationUsersWithWbAccess,
  getResourceCharges,
  getAllWbPlans,
  getOrganizationWbPlans,
  makePlanActive,
  makePlanInactive,
  updateDefaults,
  updateUserLimits,
} from './wbSubscription';
export { getFlags, getFlag, updateFlag } from './flags';
export {
  getEntitlementsReport,
  getEntitlementsReportCsvUrl,
  getEntitlementsReportSearchParams,
  type EntitlementsPermissionType,
  type EntitlementsReportRow,
  type EntitlementsReportRequest,
} from './entitlements-report';
export {
  getLicensesReport,
  getLicensesReportCsvUrl,
  getLicensesReportSearchParams,
  type LicensesReportRequest,
  type LicensesReportRow,
} from './licenses-report';
export { type PaginationParams } from './pagination';

export function ping(route: string, method = 'POST') {
  return request(`${ROOT_SERVER_URL}${route}?mode=ping`, {
    method,
  });
}
